module.exports = __webpack_public_path__ + "static/media/Tooltip-thumbnail.245d3782.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/screenCaptures/Tooltip-thumbnail.png
// module id = 1436
// module chunks = 0